module.exports = __webpack_public_path__ + "static/img/s-hw-2.07e53ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-hw-2.png
// module id = t3nv
// module chunks = 1